<div class="ladder-container">
  @for (pnl of conditionalPnLs; track pnl?.label) {
    @let label = pnl?.label;
    @let value = pnl?.pnl;
    <div class="ladder-condition">
      <span>{{ label }}</span>
      <b [ngClass]="{ 'dark-pnl-green': value >= 0, 'dark-pnl-red': value < 0 }">{{ value | number: "1.2-2" }}</b>
    </div>
  }
</div>
